import { render } from "./App.vue?vue&type=template&id=0ac8a6c2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
script.render = render

export default script